import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {UserService} from "@/service/UserService.ts";
import {UpdateUserRequest} from "@/model/request/user/UpdateUserRequest.ts";
import {UpdateUserResponse} from "@/model/response/user/UpdateUserResponse.ts";
import {CreateUserRequest} from "@/model/request/user/CreateUserRequest.ts";
import {CreateUserResponse} from "@/model/response/user/CreateUserResponse.ts";
import {ReadUserResponse, ReadUserResponseData} from "@/model/response/user/ReadUserResponse.ts";
import {ReadUserByWorkspaceIdResponse} from "@/model/response/user/ReadUserByWorkspaceIdResponse.ts";
import {ReadUserByWorkspaceIdRequest} from "@/model/request/user/ReadUserByWorkspaceIdRequest.ts";

export type UserState = {
    loading: boolean,
    user: ReadUserResponseData[],
    userByWorkspaceId: ReadUserByWorkspaceIdResponse['data']
};

const initialState: UserState = {
    loading: false,
    user: [] as ReadUserResponseData[],
    userByWorkspaceId: []

};

const action = {
    updateUser: createAsyncThunk(
        "user/action/updateUser",
        async (data: UpdateUserRequest, thunkAPI) => {
            try {
                const response: UpdateUserResponse = (await UserService.updateUser(data, thunkAPI)).data;
                return response
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e?.message as string);
            }
        }
    ),
    readUser: createAsyncThunk(
        "user/action/readUser",
        async (_, thunkAPI) => {
            try {
                const response: UpdateUserResponse = (await UserService.readAllUser(thunkAPI)).data;
                return response
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e?.message as string);
            }
        }
    ),
    readUserByWorkspaceId: createAsyncThunk("user/readUserByWorkspaceId", async (payload: ReadUserByWorkspaceIdRequest, thunkAPI) => {
        try {
            return (await UserService.readUserByWorkspaceId(thunkAPI, payload)).data
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    }),
    createUser: createAsyncThunk(
        "user/action/createUser",
        async (data: CreateUserRequest, thunkAPI) => {
            try {
                const response: CreateUserResponse = (await UserService.createUser(data, thunkAPI)).data;
                return response
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e?.message as string);
            }
        }
    ),
};
const slice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        }, reset: () => ({...initialState})
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.updateUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.updateUser.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(action.createUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.createUser.fulfilled, (state) => {
                state.loading = false;
            }).addCase(action.readUser.pending, (state) => {
            state.loading = true
        }).addCase(action.readUser.fulfilled, (state, action) => {
            const response = action.payload as ReadUserResponse;
            state.loading = false
            if (response.responseCode == "00") {
                state.user = response.data
            }
        }).addCase(action.readUserByWorkspaceId.pending, (state) => {
            state.loading = true
        }).addCase(action.readUserByWorkspaceId.fulfilled, (state, action) => {
            state.loading = false
            const response = action.payload as ReadUserByWorkspaceIdResponse
            if (response.responseCode == "00") {
                state.userByWorkspaceId = response.data
            }
        })
    },
});

export const user = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};